<template>
  <div class="productSorts" ref="container">
    <!--<form @submit.prevent="submitForm">-->
    <!--<div class="header acea-row row-center-wrapper" ref="header">-->
    <!--<div class="acea-row row-between-wrapper input">-->
    <!--<span class="iconfont icon-sousuo"></span>-->
    <!--<input-->
    <!--type="text"-->
    <!--placeholder="搜索商品信息"-->
    <!--v-model="where.keyword"-->
    <!--/>-->
    <!--</div>-->
    <!--</div>-->
    <!--</form>-->
    <div class="header acea-row row-center-wrapper">
      <router-link :to="'/search'" class="acea-row row-between-wrapper input">
        <span class="iconfont icon-sousuo"></span>
        <div class="text">搜索商品信息</div>
      </router-link>
    </div>
    <div class="nav">
      <div class="navScoll">
        <div
          class="item"
          :class="active === index ? 'font-color-green' : ''"
          v-for="(item, index) in category"
          :key="index"
          @click="oneSortTap(index)"
        >
          {{ item.cate_name }}
        </div>
      </div>
    </div>
    <div class="aside">
      <div
        class="item acea-row row-center-wrapper"
        :class="index === navActive ? 'font-color-green' : ''"
        v-for="(item, index) in categoryTwo"
        :key="index"
        @click="twoSortTap(index)"
      >
        <span>{{ item.cate_name }}</span>
      </div>
      <div style="height:1.2rem;"></div>
    </div>
    <div class="conter">
      <div class="grade acea-row row-middle">
        <div
          class="item acea-row row-center-wrapper"
          :class="gradeSwitch === 1 ? 'cart-color-green' : ''"
          @click="set_where(1)"
        >
          价格
          <img src="@assets/images/horn2.png" v-if="price === 0" />
          <img src="@assets/images/up2.png" v-if="price === 1" />
          <img src="@assets/images/down2.png" v-if="price === 2" />
        </div>
        <div
          class="item acea-row row-center-wrapper"
          :class="gradeSwitch === 2 ? 'cart-color-green' : ''"
          @click="set_where(2)"
        >
          销量
          <img src="@assets/images/horn2.png" v-if="stock === 0" />
          <img src="@assets/images/up2.png" v-if="stock === 1" />
          <img src="@assets/images/down2.png" v-if="stock === 2" />
        </div>
        <div
          class="item acea-row row-center-wrapper"
          :class="nows ? 'cart-color-green' : ''"
          @click="set_where(3)"
        >
          新品
        </div>
      </div>
      <div class="list">
        <div
          class="item acea-row row-between-wrapper"
          v-for="(item, index) in productList"
          :key="index"
          @click="goDetail(index)"
        >
          <div class="pictrue"><img :src="item.image" /></div>
          <div class="text">
            <div class="name line1">{{ item.store_name }}</div>
            <div class="sales">销量 {{ item.sales }}</div>
            <div class="money font-color-orange">
              ￥<span class="num">{{ item.price }}</span>
            </div>
          </div>
          <div
            class="specs acea-row row-center-wrapper bg-color-green"
            v-if="item.is_att"
            @click.stop="openAttr(index)"
          >
            选规格
          </div>
          <div class="cart acea-row row-center-wrapper" v-else>
            <div class="num acea-row row-center-wrapper" v-if="item.cart_num">
              <div
                class="iconfont icon-jian"
                @click.stop="productReduce(index)"
              ></div>
              <div class="cart-num">{{ item.cart_num }}</div>
            </div>
            <div
              class="iconfont icon-jia font-color-green"
              :class="item.cart_num >= item.stock ? 'on' : ''"
              @click.stop="productPlus(index)"
            ></div>
          </div>
        </div>
      </div>
      <Loading :loaded="loadend" :loading="loading"></Loading>
    </div>
    <div style="height:1.2rem;"></div>
    <ShopCart
      :cart="cart"
      v-on:reduce="reduce"
      v-on:plus="plus"
      v-on:delGood="delGood"
      v-on:settlement="settlement"
    ></ShopCart>
    <ProductAttr
      :attr="attr"
      v-on:myattr="myattr"
      v-on:changeattr="ChangeAttr"
      v-on:gocat="attrGoCat"
      v-on:attrreduce="attrReduce"
    ></ProductAttr>
  </div>
</template>
<style scoped>
.productSorts .header {
  width: 100%;
  height: 0.96rem;
  background-color: #fff;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 9;
  border-bottom: 1px solid #f5f5f5;
}
.productSorts .header .input {
  width: 7rem;
  height: 0.6rem;
  background-color: #f5f5f5;
  border-radius: 0.5rem;
  padding: 0 0.25rem;
}
.productSorts .header .input .iconfont {
  font-size: 0.35rem;
  color: #555;
}
.productSorts .header .input .text {
  font-size: 0.26rem;
  width: 5.97rem;
  color: #999;
}
.productSorts .header .input input::placeholder {
  color: #999;
}
.productSorts .nav {
  padding: 0 0.2rem;
  width: 100%;
  white-space: nowrap;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  margin-top: 0.96rem;
  height: 0.8rem;
  line-height: 0.75rem;
  border-bottom: 0.04rem solid #f5f5f5;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 9;
  background-color: #fff;
}
.productSorts .nav .navScoll {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
}
.productSorts .nav .item {
  display: inline-block;
  font-size: 0.26rem;
  color: #898989;
}
.productSorts .nav .item.font-color-green {
  font-size: 0.28rem;
  font-weight: bold;
  border-bottom: 0.04rem solid #00c049;
}
.productSorts .nav .item ~ .item {
  margin-left: 0.46rem;
}
.productSorts .aside {
  position: fixed;
  width: 1.8rem;
  left: 0;
  top: 1.76rem;
  bottom: 0;
  background-color: #f7f7f7;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  overflow-scrolling: touch;
}
.productSorts .aside .item {
  height: 0.98rem;
  width: 100%;
  font-size: 0.26rem;
  color: #424242;
  position: relative;
}
.productSorts .aside .item.font-color-green {
  background-color: #fff;
  width: 100%;
  text-align: center;
  color: #ff8500;
  font-weight: bold;
  font-size: 0.28rem;
}
.productSorts .aside .item.font-color-green::before {
  position: absolute;
  width: 0.04rem;
  height: 0.35rem;
  background-color: #00c049;
  top: 50%;
  margin-top: -0.175rem;
  left: 0;
  content: "";
}
.productSorts .conter {
  margin: 1.75rem 0 0 1.8rem;
}
.productSorts .conter .grade {
  background-color: #fff;
  padding-bottom: 0.28rem;
}
.productSorts .conter .grade .item {
  width: 1.62rem;
  height: 0.48rem;
  background-color: #f1f1f1;
  border-radius: 0.24rem;
  font-size: 0.24rem;
  color: #454545;
  margin: 0.25rem 0 0 0.2rem;
  border: 1px solid #f1f1f1;
}
.productSorts .conter .grade .item img {
  width: 0.11rem;
  height: 0.16rem;
  display: block;
  margin-left: 0.08rem;
}
.productSorts .conter .grade .item.cart-color-green {
  background-color: #f3fff7;
}
.productSorts .conter .list {
  padding: 0 0.2rem 0 0.17rem;
}
.productSorts .conter .list .item {
  margin-bottom: 0.35rem;
  width: 5.33rem;
  position: relative;
}
.productSorts .conter .list .item .pictrue {
  width: 1.58rem;
  height: 1.58rem;
}
.productSorts .conter .list .item .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 0.06rem;
}
.productSorts .conter .list .item .text {
  width: 3.55rem;
}
.productSorts .conter .list .item .text .name {
  font-size: 0.3rem;
  color: #222;
  margin-top: 0.05rem;
}
.productSorts .conter .list .item .text .sales {
  font-size: 0.22rem;
  color: #aaa;
  margin-top: 0.08rem;
}
.productSorts .conter .list .item .text .money {
  font-size: 0.28rem;
  margin-top: 0.18rem;
}
.productSorts .conter .list .item .text .money .num {
  font-size: 0.3rem;
}
.productSorts .conter .list .item .cart {
  position: absolute;
  right: 0.2rem;
  bottom: 0.15rem;
}
.productSorts .conter .list .item .cart .cart-num {
  width: 0.5rem;
  text-align: center;
}
.productSorts .conter .list .item .cart .iconfont {
  font-size: 0.45rem;
}
.productSorts .conter .list .item .cart .iconfont.on {
  color: #ddd !important;
}
.productSorts .conter .list .item .cart .iconfont.icon-jian {
  color: #ddd;
}
.productSorts .conter .list .item .specs {
  width: 1rem;
  height: 0.4rem;
  border-radius: 0.2rem;
  font-size: 0.2rem;
  position: absolute;
  right: 0.2rem;
  bottom: 0.15rem;
  color: #fff;
}
</style>
<script>
import {
  getCategory,
  getProducts,
  getProductDetail,
  postCartAdd,
  getCartCount,
  getCartList,
  postCartDel,
  changeCartNum
} from "@api/store";
import ShopCart from "@components/ShopCart";
import ProductAttr from "@components/ProductAttr";
import Loading from "@components/Loading";
import { mapGetters } from "vuex";
import debounce from "lodash.debounce";
import { mul, add } from "@utils/bc";

export default {
  name: "GoodsClass",
  components: {
    ShopCart,
    ProductAttr,
    Loading
  },
  props: {},
  data: function() {
    return {
      active: 0,
      category: [],
      categoryTwo: [],
      navActive: 0,
      productList: [],
      where: {
        page: 1,
        limit: 20,
        keyword: "",
        cid: 0, //一级分类id
        sid: 0, //二级分类id
        news: 0,
        priceOrder: "",
        salesOrder: "",
        type: 1
      },
      loading: false,
      loadend: false,
      price: 0,
      stock: 0,
      nows: false,
      gradeSwitch: 1,
      attr: {
        activeAttr: false,
        productAttr: [],
        productSelect: {}
      },
      productValue: [],
      storeInfo: {},
      attrValue: "",
      id: 0, //产品id；
      cart: {
        CartCount: 0,
        animated: false,
        cartList: [],
        countmoney: 0,
        iShidden: true
      },
      isNewOpen: true,
      invalidNum: 0,
      i: 1
    };
  },
  watch: {
    $route(n) {
      if (n.name === "GoodsClass") {
        if (this.$route.params.pid) this.where.cid = this.$route.params.pid;
        if (this.isNewOpen) {
          this.getCategoryData(this.where.cid);
        }
        this.getCartList();
        this.cart.iShidden = true;
      }
    }
  },
  computed: mapGetters(["isLogin"]),
  mounted: function() {
    this.where.cid = this.$route.params.pid;
    this.getCategoryData(this.where.cid);
    this.getCartList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getGoodlist();
    });
    // window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    // handleScroll() {
    //   // 页面滚动距顶部距离
    //   let scrollTop =
    //     window.pageYOffset ||
    //     document.documentElement.scrollTop ||
    //     document.body.scrollTop;
    //   let scroll = scrollTop - this.i;
    //   this.i = scrollTop;
    //   let u = navigator.userAgent;
    //   let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    //   if (isAndroid) {
    //     if (scroll <= 0) {
    //       this.direction = 1; //向上
    //     } else {
    //       this.direction = 0; //向下
    //     }
    //   } else {
    //     if (scroll <= 0) {
    //       this.direction = 0;
    //     } else {
    //       this.direction = 1;
    //     }
    //   }
    // },
    goDetail: function(index) {
      this.isNewOpen = false;
      this.$router.push({ path: "/detail/" + this.productList[index].id });
    },
    getCategoryData: function(navIg) {
      let that = this;
      getCategory().then(res => {
        that.$set(that, "category", res.data);
        if (navIg) {
          that.category.forEach(function(val, index) {
            if (val.id === parseInt(navIg)) {
              that.active = index;
              that.navActive = 0;
            }
          });
          if (res.data[that.active].children.length) {
            that.where.sid = res.data[that.active].children[0].id;
          } else {
            that.where.sid = "";
          }
          that.where.cid = navIg;
          that.categoryTwo = res.data[that.active].children;
        } else {
          that.where.cid = res.data[0].id;
          // that.where.sid = res.data[0].children[0].id;
          that.where.sid = res.data[0].children.length
            ? res.data[0].children[0].id
            : 0;
          that.$set(that, "categoryTwo", res.data[0].children);
        }
        that.$set(this, "productList", []);
        that.where.page = 1;
        that.loadend = false;
        that.loading = false;
        that.getGoodlist(true);
        that.getCartCount();
      });
    },
    getGoodlist: function() {
      let that = this;
      if (that.loading) return; //阻止下次请求（false可以进行请求）；
      if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
      that.loading = true;
      this.setWhere();
      let q = that.where;
      getProducts(q).then(res => {
        that.loading = false;
        that.productList.push.apply(that.productList, res.data);
        that.loadend = res.data.length < that.where.limit; //判断所有数据是否加载完成；
        that.where.page = that.where.page + 1;
      });
    },
    oneSortTap: function(index) {
      this.active = index;
      this.navActive = 0;
      this.$set(this, "categoryTwo", this.category[index].children);
      this.$set(this, "productList", []);
      this.where.cid = this.category[index].id;
      if (this.categoryTwo.length) {
        this.where.sid = this.categoryTwo[0].id;
      } else {
        this.where.sid = -1;
      }
      this.where.page = 1;
      this.loadend = false;
      this.loading = false;
      this.getGoodlist();
    },
    twoSortTap: function(index) {
      this.navActive = index;
      this.$set(this, "productList", []);
      this.where.cid = this.category[this.active].id;
      this.where.sid = this.categoryTwo[index].id;
      this.where.page = 1;
      this.loadend = false;
      this.loading = false;
      this.getGoodlist();
    },
    // submitForm: function() {
    //   this.$set(this, "productList", []);
    //   this.where.page = 1;
    //   this.loadend = false;
    //   this.loading = false;
    //   this.getGoodlist();
    // },
    //点击事件处理
    set_where: function(index) {
      let that = this;
      switch (index) {
        case 1:
          if (that.price === 0) that.price = 1;
          else if (that.price === 1) that.price = 2;
          else if (that.price === 2) that.price = 0;
          that.stock = 0;
          that.gradeSwitch = index;
          break;
        case 2:
          if (that.stock === 0) that.stock = 1;
          else if (that.stock === 1) that.stock = 2;
          else if (that.stock === 2) that.stock = 0;
          that.price = 0;
          that.gradeSwitch = index;
          break;
        case 3:
          that.nows = !that.nows;
          break;
        default:
          break;
      }
      that.$set(that, "productList", []);
      that.where.page = 1;
      that.loadend = false;
      that.loading = false;
      that.getGoodlist();
    },
    //设置where条件
    setWhere: function() {
      let that = this;
      if (that.price === 0) {
        that.where.priceOrder = "";
      } else if (that.price === 1) {
        that.where.priceOrder = "asc";
      } else if (that.price === 2) {
        that.where.priceOrder = "desc";
      }
      if (that.stock === 0) {
        that.where.salesOrder = "";
      } else if (that.stock === 1) {
        that.where.salesOrder = "asc";
      } else if (that.stock === 2) {
        that.where.salesOrder = "desc";
      }
      that.where.news = that.nows ? "1" : "0";
    },
    myattr: function(e) {
      this.attr.activeAttr = e;
      this.$set(this.attr, "productSelect", {});
    },
    openAttr: function(index) {
      let that = this;
      that.id = that.productList[index].id;
      getProductDetail(that.id, "/1").then(res => {
        that.$set(that.attr, "productAttr", res.data.productAttr);
        that.$set(that, "productValue", res.data.productValue);
        that.$set(that, "storeInfo", res.data.storeInfo);
        that.$set(
          that.attr.productSelect,
          "store_name",
          that.storeInfo.store_name
        );
        that.$set(that.attr.productSelect, "cart_num", 0);
        that.DefaultSelect();
      });
    },
    //  产品列表 加 的点击事件；
    productPlus: function(index) {
      let that = this,
        listw = that.productList;
      that.id = listw[index].id;
      if (listw[index].cart_num >= listw[index].stock) return false;
      that.goCat(index, listw);
    },
    //产品列表 加 的功能；
    publicPlus: function(index, listw) {
      listw[index].cart_num++;
      if (listw[index].cart_num >= listw[index].stock) {
        this.$set(listw, "cart_num", listw[index].stock);
      }
    },
    //  产品列表 减 的点击事件；
    productReduce: function(index) {
      let that = this,
        listw = that.productList,
        id = listw[index].id;
      that.cart.cartList.forEach(function(item, i) {
        if (id === item.product_id) {
          that.reduce(i);
        }
      });
    },
    //产品列表 减 的功能；
    publicReduce: function(index, listw) {
      listw[index].cart_num--;
      if (listw[index].cart_num <= 1) {
        this.$set(listw, "cart_num", 1);
      }
    },
    DefaultSelect: function() {
      let productAttr = this.attr.productAttr,
        value = [];
      for (var i = 0; i < productAttr.length; i++) {
        this.$set(productAttr[i], "index", 0);
        value.push(productAttr[i].attr_values[0]);
      }
      let attrTxt = value.sort().join(",");
      this.$set(this.attr.productSelect, "specs", attrTxt);
      //sort();排序函数:数字-英文-汉字；
      //join() 方法用于把数组中的所有元素放入一个字符串。
      let productSelect = this.productValue[attrTxt];
      if (productSelect) {
        this.$set(this.attr.productSelect, "image", productSelect.image);
        this.$set(this.attr.productSelect, "price", productSelect.price);
        this.$set(this.attr.productSelect, "stock", productSelect.stock);
        this.$set(this.attr.productSelect, "unique", productSelect.unique);
        this.$set(this.attr.productSelect, "cart_num", productSelect.cart_num);
        this.$set(this, "attrValue", value.sort().join(","));
      } else {
        this.$set(this.attr.productSelect, "image", this.storeInfo.image);
        this.$set(this.attr.productSelect, "price", this.storeInfo.price);
        this.$set(this.attr.productSelect, "stock", 0);
        this.$set(this.attr.productSelect, "unique", "");
        this.$set(this.attr.productSelect, "cart_num", 0);
        this.$set(this, "attrValue", "");
      }
      this.attr.activeAttr = true;
    },
    ChangeAttr: function(res) {
      this.$set(this.attr.productSelect, "specs", res);
      let productSelect = this.productValue[res];
      if (productSelect) {
        this.$set(this.attr.productSelect, "image", productSelect.image);
        this.$set(this.attr.productSelect, "price", productSelect.price);
        this.$set(this.attr.productSelect, "stock", productSelect.stock);
        this.$set(this.attr.productSelect, "unique", productSelect.unique);
        this.$set(this.attr.productSelect, "cart_num", productSelect.cart_num);
        this.$set(this, "attrValue", res);
      } else {
        this.$set(this.attr.productSelect, "image", this.storeInfo.image);
        this.$set(this.attr.productSelect, "price", this.storeInfo.price);
        this.$set(this.attr.productSelect, "stock", 0);
        this.$set(this.attr.productSelect, "unique", "");
        this.$set(this.attr.productSelect, "cart_num", 0);
        this.$set(this, "attrValue", "");
      }
    },
    //  属性购物车加；
    attrGoCat: function() {
      let attrList = this.attr.productSelect;
      if (attrList.cart_num >= attrList.stock) return;
      this.goCat();
      attrList.cart_num++;
      if (attrList.cart_num > attrList.stock) {
        this.$set(
          this.productValue[this.attrValue],
          "cart_num",
          attrList.stock
        );
      } else {
        this.$set(
          this.productValue[this.attrValue],
          "cart_num",
          attrList.cart_num
        );
      }
    },
    //属性购物车减；
    attrReduce: function() {
      let that = this,
        attrList = that.attr.productSelect;
      attrList.cart_num--;
      if (attrList.cart_num < 1) {
        that.$set(that.productValue[that.attrValue], "cart_num", 0);
      } else {
        that.$set(
          that.productValue[that.attrValue],
          "cart_num",
          attrList.cart_num
        );
      }
      that.cart.cartList.forEach(function(item, index) {
        if (attrList.unique === item.product_attr_unique) {
          let list = that.cart.cartList[index];
          list.cart_num--;
          if (list.cart_num < 1) {
            postCartDel([list.id]).then(function() {
              that.cart.cartList.splice(index, 1);
              if (that.cart.cartList.length < 1) {
                that.cart.iShidden = true;
              }
            });
          }
          that.countMoney();
          that.syncCartNum(list);
        }
      });
    },
    // 加入购物车；
    goCat: function(index, listw) {
      let that = this;
      let q = {
        productId: that.id,
        cartNum: 1,
        new: 0,
        uniqueId:
          that.attr.productSelect !== undefined
            ? that.attr.productSelect.unique
            : ""
      };
      postCartAdd(q)
        .then(() => {
          that.getCartCount(true);
          that.getCartList();
          if (index !== undefined) {
            that.publicPlus(index, listw);
          }
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    //获取购物车数量
    getCartCount: function(isAnima) {
      let that = this;
      const isLogin = that.isLogin; //true为登录状态；
      if (isLogin) {
        getCartCount({ numType: 0 }).then(res => {
          that.cart.CartCount = res.data.count - that.invalidNum;
          if (isAnima) {
            that.cart.animated = true;
            setTimeout(function() {
              that.cart.animated = false;
            }, 500);
          }
        });
      }
    },
    getCartList: function() {
      let that = this;
      const isLogin = that.isLogin;
      if (isLogin) {
        getCartList().then(res => {
          that.$set(that.cart, "cartList", res.data.valid);
          let cartNum = 0;
          let invalid = res.data.invalid;
          for (let i = 0; i < invalid.length; i++) {
            cartNum = add(cartNum, invalid[i].cart_num);
          }
          that.invalidNum = cartNum;
          that.countMoney();
        });
      }
    },
    //购物车加
    plus: function(index) {
      let that = this;
      let list = that.cart.cartList[index];
      that.productId(list, 1);
      list.cart_num++;
      if (list.productInfo.attrInfo) {
        if (list.cart_num >= list.productInfo.attrInfo.stock) {
          that.$set(list, "cart_num", list.productInfo.attrInfo.stock);
        }
      } else {
        if (list.cart_num >= list.productInfo.stock) {
          that.$set(list, "cart_num", list.productInfo.stock);
        }
      }
      that.countMoney();
      that.syncCartNum(list);
    },
    //购物车减
    reduce: function(index) {
      let that = this;
      let list = that.cart.cartList[index],
        productId = list.product_id;
      that.productId(list, 0);
      list.cart_num--;
      if (list.cart_num < 1) {
        postCartDel([list.id]).then(function() {
          that.cart.cartList.splice(index, 1);
          that.productList.forEach(function(item, index) {
            if (productId === item.id) {
              that.productList[index].cart_num = 0;
            }
          });
          if (that.cart.cartList.length < 1) {
            that.cart.iShidden = true;
          }
        });
      }
      that.countMoney();
      that.syncCartNum(list);
    },
    //获取当前购物车在产品列表对应id的index值；
    productId: function(list, status) {
      let that = this;
      let id = list.product_id;
      let listw = that.productList;
      listw.forEach(function(item, i) {
        if (id === item.id) {
          if (status) {
            that.publicPlus(i, listw);
          } else {
            that.publicReduce(i, listw);
          }
        }
      });
    },
    //  修改购物车数量；
    syncCartNum(cart) {
      if (!cart.sync)
        cart.sync = debounce(() => {
          changeCartNum(cart.id, Math.max(cart.cart_num, 1) || 1).then(() => {
            this.getCartCount();
          });
        }, 500);
      cart.sync();
    },
    //总共价钱；
    countMoney: function() {
      let that = this;
      let carmoney = 0;
      let array = that.cart.cartList;
      for (let i = 0; i < array.length; i++) {
        carmoney = add(carmoney, mul(array[i].cart_num, array[i].truePrice));
      }
      that.$set(that.cart, "countmoney", carmoney);
    },
    delGood: function() {
      let that = this,
        id = [],
        productId = [],
        listw = that.productList,
        list = that.cart.cartList;
      list.forEach(function(val) {
        id.push(val.id);
        productId.push(val.product_id);
      });
      postCartDel(id).then(function() {
        list.splice(0, list.length);
        that.countMoney();
        that.getCartCount();
        that.cart.iShidden = true;
        listw.forEach(function(item, index) {
          productId.forEach(function(itemId) {
            if (item.id === itemId) {
              listw[index].cart_num = 0;
            }
          });
        });
      });
    },
    settlement: function() {
      let that = this,
        list = that.cart.cartList,
        id = [];
      list.forEach(function(val) {
        id.push(val.id);
      });
      if (id.length > 0) {
        that.$router.push({ path: "/order/submit/" + id.join(",") });
        that.cart.iShidden = true;
      } else {
        that.$dialog.toast({ mes: "请选择产品" });
      }
    }
  }
};
</script>
